/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Where_AnswerInputs */

const en_faq_where_answer = /** @type {(inputs: Faq_Where_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small and mid-sized companies that want practical AI automation rather than an AI strategy deck. We are based in Liepāja, Latvia, work in Latvian and English, and work with businesses across the Baltics and Europe, including Lithuania, Estonia, Finland, Germany, Norway, Poland and Sweden.`)
};

const lv_faq_where_answer = /** @type {(inputs: Faq_Where_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar maziem un vidējiem uzņēmumiem, kam vajag praktisku AI automatizāciju, nevis AI stratēģijas prezentāciju. Mēs atrodamies Liepājā, strādājam latviešu un angļu valodā un sadarbojamies ar uzņēmumiem visā Baltijā un Eiropā, tostarp Lietuvā, Igaunijā, Somijā, Vācijā, Norvēģijā, Polijā un Zviedrijā.`)
};

/**
* | output |
* | --- |
* | "Small and mid-sized companies that want practical AI automation rather than an AI strategy deck. We are based in Liepāja, Latvia, work in Latvian and English..." |
*
* @param {Faq_Where_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_where_answer = /** @type {((inputs?: Faq_Where_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Where_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_where_answer(inputs)
	return en_faq_where_answer(inputs)
});